<script setup>
import {ref, computed} from 'vue';
import BetCalcSelectionOdds from "@/components/bet_calc/BetCalcSelectionOdds.vue";
import BetCalcBetType from "@/components/bet_calc/BetCalcBetType.vue";
import BetCalcStake from "@/components/bet_calc/BetCalcStake.vue";
import BetCalcOddsType from "@/components/bet_calc/BetCalcOddsType.vue";

const stake = ref(10);
const oddsType = ref('decimal');
const betType = ref('stakeReturned');
const decimalOdds = ref('2');


const result = computed(() => {
  const decimal = parseFloat(decimalOdds.value)
  if (decimal && !isNaN(decimal)) {
    if (betType.value === 'stakeReturned') {
      return (stake.value * decimal).toFixed(2);
    } else {
      return (stake.value * (decimal - 1)).toFixed(2);
    }
  }
  return null;
});

const updateDecimalOdds = (newDecimalOdds) => {
  decimalOdds.value = newDecimalOdds;
};
</script>

<template>
  <div class="bet-calc-single-bet-calculator">
    <BetCalcOddsType v-model="oddsType"/>
    <BetCalcBetType v-model="betType"/>
    <BetCalcStake v-model="stake" style="margin: 0.5rem"/>
    <BetCalcSelectionOdds
        :oddsType="oddsType"
        label="Odds:"
        @update:decimalOdds="updateDecimalOdds"
        style="margin: 1.5rem 0.5rem"
    />
    <div class="bet-calc-single-result" v-if="result">
      <h4 class="heading-medium">Bet Return: {{ result }}</h4>
    </div>
  </div>
</template>

<style scoped>
.bet-calc-single-bet-calculator {
  max-width: 576px;
  margin: 0 auto;
  padding: 20px;
  background-color: var(--clr-black-10);
}
</style>
